import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import Store from "./redux/Store";
import {Provider} from "react-redux";

import './services/i18n';
import CustomThemeProvider from "./components/base/CustomThemeProvider";
import {AuthProvider} from "./context/AuthContext";

ReactDOM.render(
  <Provider store={Store}>
      <CustomThemeProvider>
          <BrowserRouter>
              <AuthProvider>
                  <App />
              </AuthProvider>
          </BrowserRouter>
      </CustomThemeProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
